// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3StsS","header":"MessagesList_header__3mpOn","chat":"MessagesList_chat__NN1Ro"};